









































































import { Component, Prop, Vue } from "vue-property-decorator";
import { InputText, InputNumber, InputDate, InputSelect } from "./input";
import { ITransactionType } from "@/interfaces";

@Component({
  components: {
    InputText,
    InputNumber,
    InputDate,
    InputSelect,
  },
})
export default class TransactionSearchForm extends Vue {
  get types() {
    return this.$store.getters["network/enabledTransactionTypes"];
  }

  get selectOptions() {
    return this.types.map((type) => ({
      value: type.key,
      display: this.$t(`TRANSACTION.TYPES.${type.key}`),
    }));
  }

  private onInputChange(event: any) {
    const { name, value } = event.target;

    this.emitInput({ name, value });
  }

  private onTypeChange(event: any) {
    const index: number = this.types.findIndex((transaction) => transaction.key === event.target.value);
    const { type, typeGroup } = this.types[index];

    this.emitInput({ name: "type", value: type !== -1 ? type : null });
    this.emitInput({ name: "typeGroup", value: typeGroup });
  }

  private emitInput(value: object) {
    this.$emit("formChange", value);
  }

  private onEnterKey(event: any) {
    this.$emit("search");
  }
}
